import _ from 'lodash'

export default {
  SET_STATE: (state, payload) => {
    _.set(state, payload.action, payload.data)
  },
  setTax: (state, { type, value, category }) => {
    const i = state.taxes && state.taxes[type][category]
    i.tax_per = value
  },
  SET_STOCK_PHOTO: (state, list) => {
    state.stock_photos = list
  },
  SET_LOADING: (state, status) => {
    state.loading = status
  }
}
